<template>
  <LoaderCar v-if="loading" width="600px" marginTop="0"/>
  <div class="codePrepa" v-else>
    <Toast />

    <div class="neph-banner" v-if="!$store.state.numNeph">
      <div class="neph-banner__icon">
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="#b45309" stroke-width="1.5"/><path d="M12 8v4M12 16h.01" stroke="#b45309" stroke-width="2" stroke-linecap="round"/></svg>
      </div>
      <p class="neph-banner__text">
        Vous pouvez vous préparer au code. Pour information, vous n'avez pas encore obtenu votre numéro NEPH, nécessaire pour le passage des examens de code et de conduite.
        RDV dans <span class="neph-banner__link" @click="goToDossier">DOSSIER</span> pour suivre l'avancement et éventuellement déposer des pièces manquantes.
      </p>
    </div>

    <div class="greetin">
      <p><span @click="goToHome" style="cursor:pointer">Accueil</span> > Code</p>
      <h1>Code</h1>
      <p>Préparation à l'examen du code de la route</p>
    </div>
    <div class="step">
      <div class="carte prepacode">
        <div class="header-carte">
          <div class="icon-carte">
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
              <path
                d="M12 2L2 7l10 5 10-5-10-5z"
                stroke="#3b82f6"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
              <path
                d="M2 17l10 5 10-5M2 12l10 5 10-5"
                stroke="#3b82f6"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="title-carte">
            <p>ETAPE 1</p>
            <p>Préparation</p>
          </div>
        </div>
        <div class="content-carte">
          <a class="link-box" href="https://www.prepacode-enpc.fr" target="_blank" rel="noopener">
            <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
              <rect
                x="4"
                y="2"
                width="16"
                height="20"
                rx="2"
                stroke="#3b82f6"
                stroke-width="1.5"
              />
              <path
                d="M8 7h8M8 11h8M8 15h5"
                stroke="#3b82f6"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
            <span class="link-box-label">ACCÈS AU<br />PREPACODE</span>
          </a>
          <div class="actions">
            <p>VOS IDENTIFIANTS</p>
            <span class="waiting-id" v-if="this.student.prepacode[0].status == null">En attente de vos identifiants</span>
            
            <button @click="sendId(student)" class="btn-secondary-carte" v-if="this.student.prepacode != null && this.student.prepacode[0].status != null">✉ Renvoyer par mail</button>
            <p  v-if="this.student.prepacode != null && this.student.prepacode[0].status != null">SCORE DERNIER TEST</p>
            <select v-model="scoreprepa" @change="changeScore(student)" name="score" id="score"  v-if="this.student.prepacode != null && this.student.prepacode[0].status != null && this.student.score === null">
              <option value="" disabled>Score dernier test</option>
              <option v-for="(s, index) in 40" :value="s" :key="index">
                {{ s }} / 40
              </option>
            </select>
            
            <button type="button" class="prepa-badge score-badge" @click="deleteScore(student)" v-if="this.student.score !== null">
                <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><path d="M13 10V3L4 14h7v7l9-11h-7z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>
                {{ this.student.score }} / 40
            </button>
                    
          </div>
        </div>
      </div>
      <div class="carte exam">
        <div class="header-carte">
          <div class="icon-carte-exam">
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
              <path
                d="M9 12l2 2 4-4"
                stroke="#1a9e6e"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="#1a9e6e"
                stroke-width="1.5"
              />
            </svg>
          </div>
          <div class="title-carte">
            <p>ETAPE 2</p>
            <p>Réservez votre examen de code</p>
          </div>
        </div>
        <div class="content-carte">
          <a
            class="link-box-exam"
            :href="`${publicPath}pdf/tuto-etg-vdef.pdf`"
            download="Tuto pour réserver votre examen.pdf"
            target="_blank"
          >
            <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
              <rect
                x="3"
                y="4"
                width="18"
                height="18"
                rx="2"
                stroke="#1a9e6e"
                stroke-width="1.5"
              />
              <path
                d="M3 10h18M8 4V2M16 4V2"
                stroke="#1a9e6e"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M8 14h2M12 14h4M8 17h4"
                stroke="#1a9e6e"
                stroke-width="1.2"
                stroke-linecap="round"
              />
            </svg>
            <span class="link-box-exam-label">TUTO POUR RESERVER VOTRE<br />EXAMEN</span>
          </a>
          <div class="actions">
            <p>DATE D'EXAMEN RESERVEE</p>
            <div class="examen-date-picker" v-if="this.student.examen === null">
              <Calendar
                inputId="dateexam"
                v-model="dateExamen"
                showTime
                hourFormat="24"
                dateFormat="dd/mm/yy"
                :touchUI="isMobile"
                placeholder="jj/mm/aaaa --:--"
                @hide="changedateExam(student)"
              />
            </div>

            <button type="button" class="score-badge score-high" @click="deletedateExam(student)" v-if="this.student.examen !== null">
                <svg width="14" height="22" fill="none" viewBox="0 0 24 24">
                    <rect
                        x="3"
                        y="4"
                        width="18"
                        height="18"
                        rx="2"
                        stroke="#1a9e6e"
                        stroke-width="1.5"
                    />
                    <path
                        d="M3 10h18M8 4V2M16 4V2"
                        stroke="#1a9e6e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                    />
                    <path
                        d="M8 14h2M12 14h4M8 17h4"
                        stroke="#1a9e6e"
                        stroke-width="1.2"
                        stroke-linecap="round"
                    />
                </svg>
                {{ this.student.examen }} H
            </button>

            <p>RESULTAT A L'EXAMEN</p>
            <select name="score" id="score" v-if="student.examen !== null && student.resultat === null" v-model="resultatExam" @change="changeResultat(student)">
              <option value=null disabled>Score examen</option>
              <option v-for="(s, index) in 40" :value="s" :key="index">
                {{ s }} / 40
              </option>
            </select>

            <button type="button" class="exam-score score-badge " @click="deleteResultat(student)" v-if="student.resultat !== null">
                <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><path d="M13 10V3L4 14h7v7l9-11h-7z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>
                {{ student.resultat }} / 40
            </button>

          </div>
        </div>

        <span class="result-exam-good" v-if="student.resultat >= 35">
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                <path d="M9 12l2 2 4-4" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="12" r="9" stroke="#1a9e6e" stroke-width="1.5"/>
            </svg>
            Vous avez obtenu votre code. Passons à la conduite ! 
        </span>

        <span class="result-exam-bad" v-if="student.resultat < 35 && student.resultat !== null">
          <svg width="12" height="12" fill="none" viewBox="0 0 24 24">
            <path
              d="M13 10V3L4 14h7v7l9-11h-7z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round"
            />
          </svg>
          Dommage examen échoué, veuillez reprendre une date !
        </span>
      </div>
    </div>

    <div style="margin-top: 24px">
      <div class="method-panel">
        <h2>La Bonne méthode</h2>

        <div class="method-step">
          <div class="method-step-title">
            <span class="method-step-num">I</span>
            D'abord travailler les thèmes
          </div>
          <div class="method-sub">
            <div class="method-sub-item">Livre de code : lire le 1er thème</div>
            <div class="method-sub-item">
              Prépacode : faire les tests du 1er thème
            </div>
            <div class="method-sub-item">Faire de même pour chaque thème</div>
          </div>
        </div>

        <div class="method-sep"></div>

        <div class="method-step">
          <div class="method-step-title">
            <span class="method-step-num">II</span>
            Ensuite travailler les séries d'entraînement
          </div>
          <div class="method-sub">
            <div class="method-sub-item">
              Faire plusieurs séries d'entraînement
            </div>
            <div class="method-sub-item">
              Vérifier votre niveau par thème et relire les thèmes avec un
              mauvais score
            </div>
            <div class="method-sub-item">
              À la fin de chaque session, reporter votre score (/40) dans le
              champ prévu
            </div>
          </div>
        </div>

        <div class="method-sep"></div>

        <div class="method-step" style="margin-bottom: 0">
          <div class="method-step-title">
            <span class="method-step-num">III</span>
            Enfin, travailler les examens blancs
          </div>
        </div>

        <div class="method-tip">
          IV) Vous avez au moins 35/40 de manière régulière ? → Réservez votre
          place d'examen
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoaderCar from '../../LoaderCar.vue';
import { useToast } from "primevue/usetoast";

export default {

    components: {
        LoaderCar
    },

    data() {
        return {
            student : [],
            score: [],
            loading: true,
            toast: useToast(),
            scoreprepa: "",
            dateExamen: null,
            resultatExam: null,
            publicPath: process.env.BASE_URL
        }
    },

    computed: {
        isMobile() {
            return window.innerWidth <= 768;
        },
    },

    mounted() {
        this.getStudentCodeInfo();
        this.fetchNumNeph();
    },

    methods: {

        fetchNumNeph() {
            window.api
                .get("/eleve/home/info/" + this.$store.state.user.id, {
                    headers: { Authorization: "Bearer " + this.$store.state.token },
                })
                .then((response) => {
                    this.$store.commit("setNumNeph", response.data.info.dossier.neph ?? null);
                })
                .catch(() => {});
        },

        goToHome() {
          this.$router.push({ name: "Home" });
        },

        goToDossier() {
          window.api
            .get("/student/" + this.$store.state.user.id + "/paiement/dossier", {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
            .then((response) => {
              if (!response.data.paid) {
                this.$router.push({ name: "Dossier-paiement" });
              } else {
                this.$router.push({ name: "Piece" });
              }
            })
            .catch(() => {
              this.$router.push({ name: "Piece" });
            });
        },

        changeResultat(student) {

            let archive = false;

            if (this.resultatExam >= 35) {
                archive = true;
            }

            window.api
            .patch(
            "/prepacodes/" + student.prepacode[0].id,
            {
                resultExamen: this.resultatExam,
                archive: archive,
            },
            {
                headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "application/merge-patch+json",
                },
            }
            )
            .then(() => {
                this.getStudentCodeInfo();
                
                if(this.resultatExam < 35){
                    this.toast.add({
                    severity: "warn",
                    summary: "Dommage ! retentez votre chance !",
                    detail: "Vous avez échoué à l'examen. Merci de réserver une nouvelle date",
                    life: 5000,
                    });
                }else{
                    this.toast.add({
                    severity: "success",
                    summary: "Félicitaion",
                    detail: "Vous avez obtenu votre code. Passons à la conduite !",
                    life: 5000,
                    });
                }
                })
            .catch((error) => {
                console.log(error);
            });
        },

        deleteResultat(student) {
            let res = confirm("Êtes-vous sûr de vouloir supprimer votre resultat à l'examen ?");
            if(res){
                window.api
                .patch(
                "/prepacodes/" + student.prepacode[0].id,
                {
                    resultExamen: null,
                    archive: false
                },
                {
                    headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                    "Content-Type": "application/merge-patch+json",
                    },
                }
                )
                .then(() => {
                    this.getStudentCodeInfo();
                })
                .catch((error) => {
                    console.log(error);
                });
            }

        },

        formatDateTimeLocal(date) {
            if (!date) return null;
            const pad = (n) => String(n).padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },

        changedateExam(student) {
            if (this.dateExamen === null) return;
            window.api
                .patch(
                "/prepacodes/" + student.prepacode[0].id,
                {
                    dateExamen: this.formatDateTimeLocal(this.dateExamen),
                },
                {
                    headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                    "Content-Type": "application/merge-patch+json",
                    },
                }
                )
                .then(() => {
                    this.getStudentCodeInfo();
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        deletedateExam(student) {
            let res = confirm("Êtes-vous sûr de vouloir supprimer la date de votre examen ?");
            if(res){
                window.api
                    .patch(
                    "/prepacodes/" + student.prepacode[0].id,
                    {
                        dateExamen: null,
                        resultExamen: null,
                    },
                    {
                        headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                        "Content-Type": "application/merge-patch+json",
                        },
                    }
                    )
                    .then(() => {
                        this.resultatExam = null;
                        this.student.resultat = null;
                        this.getStudentCodeInfo();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }

        },

        deleteScore(student) {
        let res = confirm("Êtes-vous sûr de vouloir supprimer votre score ?");
            if(res){
                window.api
                    .patch(
                    "/prepacodes/" + student.prepacode[0].id,
                    {
                        scorePrepaCode: null,
                    },
                    {
                        headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                        "Content-Type": "application/merge-patch+json",
                        },
                    }
                    )
                    .then(() => {
                        this.getStudentCodeInfo();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }

        },

        changeScore(student) {
            window.api
                .patch(
                "/prepacodes/" + student.prepacode[0].id,
                {
                    scorePrepaCode: this.scoreprepa,
                },
                {
                    headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                    "Content-Type": "application/merge-patch+json",
                    },
                }
                )
                .then(() => {
                    this.getStudentCodeInfo();
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getStudentCodeInfo(){
            window.api
                .get("/student/code/" + this.$store.state.user.id, {
                headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                },
                })
                .then((response) => {
                    this.student = response.data.student[0];

                    let scoreTab = [];

                    for (let index = 0; index <= 40; index++) {
                        scoreTab.push({ value: index });
                    }
                    this.score = scoreTab;
                    this.loading = false;

                    this.$nextTick(() => {
                        if(this.student.score !== null){
                            const scoreBadge = document.querySelector(".prepa-badge");
                            if(scoreBadge){
                                if(this.student.score < 20){
                                    scoreBadge.classList.add("score-low");
                                }else if(this.student.score < 35){
                                    scoreBadge.classList.add("score-mid");
                                }else{
                                    scoreBadge.classList.add("score-high");
                                }
                            }
                        }

                        if(this.student.resultat !== null){
                            const examBadge = document.querySelector(".exam-score");
                            if(examBadge){
                                if(this.student.resultat < 35){
                                    examBadge.classList.add("score-low");
                                }else{
                                    examBadge.classList.add("score-high");
                                }
                            }
                        }
                    });

                })
                .catch((error) => {
                console.log(error);
                });
        },

        sendId(student){
            window.api
                .get("give/prepacode/" + student.id, {
                    headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                    },
                })
                .then(() => {
                    this.getStudentCodeInfo();

                    this.toast.add({
                    severity: "success",
                    summary: "ID Prepacode reçu dans votre boite mail",
                    detail: "N'oubliez pas de regarder dans vos spams au cas où !",
                    life: 6000,
                    });

                })
                .catch((error) => {
                    console.log(error);
                });
        },

    },
};
</script>
<style scoped>
/* ===== Bandeau NEPH manquant ===== */
.neph-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fffbeb;
  border: 1.5px solid #fcd34d;
  border-radius: 12px;
  padding: 14px 18px;
  margin-top: 16px;
  margin-bottom: 20px;
}

.neph-banner__icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.neph-banner__text {
  font-size: 14px;
  color: #92400e;
  line-height: 1.55;
  margin: 0 !important;
}

.neph-banner__link {
  font-weight: 700;
  color: #b45309;
  text-decoration: underline;
  cursor: pointer;
}
.neph-banner__link:hover {
  color: #92400e;
}

div.codePrepa {
  text-align: left;
  margin: auto;
  margin-top: 3rem;
  width: 55%;
}

div.codePrepa p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

div.codePrepa h1 {
  font-weight: bold;
}

div.codePrepa div.step {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 3rem;
}

div.step div.carte {
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 30px;
  width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    min-width: 0;
}


div.codePrepa div.step div.carte:hover{
    transform: translateY(-3px); 
    box-shadow: 0 12px 32px rgba(0,0,0,.07); 
    cursor: pointer;
}

div.codePrepa div.step div.prepacode:hover{
    border-top: 4px solid #0d6efd;
}

div.codePrepa div.step div.exam:hover{
    border-top: 4px solid #1a9e6e;
}

div.codePrepa div.step div.carte .header-carte {
  display: flex;
  padding-bottom: 1rem;
  border-radius: 16px;
  border-bottom: 1px solid #e2e8f0;
}

div.codePrepa div.step div.carte .header-carte div.icon-carte {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eff6ff;
  margin-right: 1rem;
}

div.codePrepa div.step div.carte .header-carte div.icon-carte-exam {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e8f7f1;
  margin-right: 1rem;
}

div.codePrepa div.step div.carte .header-carte div.title-carte p:first-of-type {
  margin: 0;
  color: #94a3b8;
}

div.codePrepa div.step div.carte .header-carte div.title-carte p:last-of-type {
  margin: 0;
  color: #000000;
  font-weight: bold;
}

div.codePrepa div.step div.carte div.content-carte {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

div.codePrepa div.step div.carte div.content-carte .link-box {
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 90px;
  transition: all 0.18s;
  cursor: pointer;
  background: #fff;
}
div.codePrepa div.step div.carte div.content-carte .link-box:hover {
  border-color: #0d6efd;
  background: #eff6ff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.1);
}
div.codePrepa div.step div.carte div.content-carte .link-box-label {
  font-size: 12px;
  font-weight: 600;
  color: #0d6efd;
  letter-spacing: 0.01em;
  line-height: 1.3;
}

div.codePrepa div.step div.carte div.content-carte .link-box-exam {
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 90px;
  transition: all 0.18s;
  cursor: pointer;
  background: #fff;
}
div.codePrepa div.step div.carte div.content-carte .link-box-exam:hover {
  border-color: #36aa7f;
  background: #e8f7f1;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.1);
}
div.codePrepa div.step div.carte div.content-carte .link-box-exam-label {
  font-size: 12px;
  font-weight: 600;
  color: #36aa7f;
  letter-spacing: 0.01em;
  line-height: 1.3;
}

div.codePrepa div.step div.carte div.content-carte .btn-secondary-carte {
  font-size: 11px;
  font-weight: bold;
  color: #6f7781;
  background: #f4f6f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  letter-spacing: 0.02em;
  margin-bottom: 0.5rem;
}

div.codePrepa div.step div.carte div.content-carte .btn-secondary-carte:hover {
  background: #fff;
  border-color: black;
  color: black;
}

div.codePrepa div.step div.carte div.content-carte .examen-date-picker {
  width: 100%;
}

div.codePrepa div.step div.carte div.content-carte .examen-date-picker :deep(.p-calendar) {
  width: 100%;
}

div.codePrepa div.step div.carte div.content-carte .examen-date-picker :deep(.p-inputtext) {
  width: 100%;
  font-size: 11px;
  font-weight: bold;
  color: #6f7781;
  background: #f4f6f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 12px;
  letter-spacing: 0.02em;
}

div.codePrepa div.step div.carte div.content-carte .examen-date-picker :deep(.p-inputtext:hover),
div.codePrepa div.step div.carte div.content-carte .examen-date-picker :deep(.p-inputtext:focus) {
  border-color: black;
  color: black;
}

div.codePrepa div.step div.carte div.content-carte select {
  background-color: #f4f6f9;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  padding: 5px;
}

 .score-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  width: 100%;
  cursor: pointer;
  border: none;
  background: transparent;
  font-family: inherit;
  outline: none;
  -webkit-tap-highlight-color: transparent;
}

.score-badge:hover{
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.1);
}

.score-low {
  background: #fff1f2;
  color: #be123c;
}
.score-mid {
  background: #fef3c7;
  color: #b45309;
}
.score-high {
  background: #e8f7f1;
  color: #065f46;
}

div.codePrepa div.step div.carte span.result-exam-bad {
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: #fff1f2;
    border: 1px solid #be123c;
    padding: 7px;
    border-radius: 10px;
    width: 100%;
    box-sizing: border-box; /* ← évite le débordement */
    font-size: 13px;
}

span.waiting-id{
  background-color: #CDEBF8;
  border: 1px solid #1288BE;
  color: #1288BE;
  padding: 7px;
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;
  font-size: 13px;
  display: flex;
  align-items: center;
}

div.codePrepa div.step div.carte span.result-exam-good {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #e8f7f1;
  border: 1px solid #065f46;
  padding: 7px;
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;
  font-size: 13px;
}

/* ===================== METHOD PANEL ===================== */
.method-panel {
  background: linear-gradient(135deg, #ff6b9d 0%, #ff9a3c 50%, #ffd166 100%);
  border-radius: 16px;
  padding: 32px 28px;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.method-panel::before {
  content: "";
  position: absolute;
  top: -60px;
  right: -60px;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
}

.method-panel::after {
  content: "";
  position: absolute;
  bottom: -80px;
  left: -40px;
  width: 250px;
  height: 250px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 50%;
}

.method-panel h2 {
  font-family: "DM Serif Display", serif;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 24px;
  opacity: 0.97;
  position: relative;
  z-index: 1;
}

.method-step {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.method-step-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin-bottom: 6px;
  opacity: 0.95;
  display: flex;
  align-items: center;
  gap: 8px;
}

.method-step-num {
  width: 22px;
  height: 22px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.method-sub {
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.method-sub-item {
  font-size: 12px;
  opacity: 0.85;
  padding: 3px 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.method-sub-item::before {
  content: "→";
  opacity: 0.6;
  flex-shrink: 0;
  margin-top: 1px;
}

.method-tip {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 12px;
  font-weight: 600;
  opacity: 0.95;
  margin-top: 20px;
  position: relative;
  z-index: 1;
}

.method-sep {
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 14px 0;
  position: relative;
  z-index: 1;
}


@media (max-width: 1200px) {
    div.codePrepa div.step {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
        margin-top: 3rem;
    }

    div.codePrepa{
        width: 90%;
    }
}
</style>
